import { render, staticRenderFns } from "./MyLeaves.vue?vue&type=template&id=7335cf4e&"
import script from "./MyLeaves.vue?vue&type=script&lang=ts&"
export * from "./MyLeaves.vue?vue&type=script&lang=ts&"
import style0 from "./MyLeaves.vue?vue&type=style&index=0&id=7335cf4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports